// 英语（美国）
export default {
  ai: {
    menuStyle: 'AI Style Preset',
    menuQuota: 'AI Quota',
    menuUsage: 'AI Usage',
    addStyle: 'Add Style',
    editStyle: 'Edit Style',
    styleName: 'Style Name',
    styleNameEn: 'English Name',
    stylePrompt: 'Prompt',
    previewUrl: 'Preview / Reference',
    builtIn: 'Built-in',
    custom: 'Custom',
    type: 'Type',
    belongCompany: 'Company',
    sortOrder: 'Sort',
    copyStyle: 'Copy',
    copySuccess: 'Copied successfully',
    copyFailed: 'Copy failed',
    confirmDeleteStyle: 'Delete this style?',
    builtInNoEdit: 'Built-in styles cannot be edited. Please copy it as a custom style first.',
    promptRequired: 'Please enter the prompt',
    nameRequired: 'Please enter the style name',
    uploadPreview: 'Upload preview',
    promptPlaceholder: 'e.g. Chinese ink painting, strictly keep facial features unchanged',
    allTypes: 'All Types',
    recharge: 'Recharge',
    rechargeTitle: 'Quota Recharge',
    newRecharge: 'New Recharge',
    companyCode: 'Company Code',
    companyName: 'Company Name',
    quotaStatus: 'Status',
    quotaTotal: 'Total Quota',
    quotaUsed: 'Used',
    quotaRemain: 'Remaining',
    unitPrice: 'Unit Price (CNY/img)',
    currency: 'Currency',
    updateTime: 'Update Time',
    addQuota: 'Add Quota',
    enabled: 'Enabled',
    disabled: 'Disabled',
    openAi: 'Enable',
    closeAi: 'Disable',
    rechargeSuccess: 'Recharged successfully',
    rechargeFailed: 'Recharge failed',
    companyCodeRequired: 'Please enter company code',
    addQuotaRequired: 'Please enter the quota amount',
    confirmOpen: 'Enable AI for this company?',
    confirmClose: 'Disable AI for this company?',
    operateSuccess: 'Operation succeeded',
    dateRange: 'Date Range',
    invokeCount: 'Invocations',
    successCount: 'Succeeded',
    generatedNum: 'Generated',
    costAmount: 'Total Cost (CNY)',
    trend: 'Daily Trend',
    byCompany: 'By Company',
    byDevice: 'By Device',
    deviceCode: 'Device Code',
    day: 'Date',
    last7: 'Last 7 days',
    last30: 'Last 30 days',
    menuRecord: 'AI Invoke Records',
    deviceName: 'Device Name',
    deviceCount: 'Assigned Devices',
    unlimited: 'Unlimited',
    assignDevices: 'Assign Devices',
    assignTips: 'Leaving empty means no restriction: all devices can use this style',
    selectDevices: 'Please select devices',
    companyRequired: 'Please select a company',
    selectCompany: 'Please select a company',
    orderCode: 'Order No.',
    status: 'Status',
    allStatus: 'All Status',
    success: 'Success',
    failed: 'Failed',
    model: 'Model',
    size: 'Size',
    requestId: 'Request ID',
    costMs: 'Cost (ms)',
    createTime: 'Invoke Time',
    errMsg: 'Error',
    sourceImages: 'Source Images',
    resultImages: 'Generated Images',
    viewDetail: 'Detail',
    recordDetail: 'Invoke Detail',
    noImage: 'No image',
    capability: 'Capability',
    styleId: 'Style ID',
    productType: 'Play Type',
    selectProductType: 'Select play type',
    printSpec: 'Print Spec',
    selectPrintSpec: 'Select print spec',
    pixelSize: 'Pixel Size',
    sizeTier: 'Size Tier',
    selectSizeTier: 'Select size tier',
    retryPrice: 'Retry Price (CNY)',
    recommendedPeople: 'Recommended People'
  },
  login: {
    username: 'Username',
    password: 'Password',
    login: 'Login',
    inputUsername: 'Please enter username',
    inputPassword: 'Please enter password'
  },
  autoLogin: {
    loading: 'Logging in as merchant, please wait...',
    missingParams: 'Missing auto-login parameters, please start again from the merchant list',
    failed: 'Merchant auto-login failed, please check the account or password'
  },
  forgotPwd: {
    forgot: 'Forgot password?',
    title: 'Reset Password',
    email: 'Email',
    inputEmail: 'Please enter your registered email',
    invalidEmail: 'Invalid email format',
    code: 'Verification Code',
    inputCode: 'Please enter the email code',
    sendCode: 'Send Code',
    newPassword: 'New Password',
    inputNewPassword: 'Please enter a new password (min 6 characters)',
    confirmPassword: 'Confirm New Password',
    inputConfirmPassword: 'Please re-enter the new password',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordNotMatch: 'The two passwords do not match',
    submit: 'Reset',
    cancel: 'Cancel',
    sendSuccess: 'Verification code sent, please check your email',
    sendFail: 'Failed to send the code, please try again later',
    resetSuccess: 'Password reset successfully, please log in again',
    resetFail: 'Failed to reset the password, please try again later'
  },
  employee: {
    inputAccount: 'Please enter account',
    inputName: 'Please enter name',
    inputMobile: 'Please enter mobile number',
    selectRole: 'Please select role',
    allRoles: 'All roles',
    allStatus: 'All status',
    collapse: 'Collapse',
    expand: 'Expand',
    employeeCount: 'Employees: ',
    addEmployee: '+ Add Employee',
    account: 'Account',
    name: 'Name',
    gender: 'Gender',
    role: 'Role',
    company: 'Company',
    creator: 'Added By',
    createTime: 'Added Time',
    devicePermission: 'Device Permission',
    deviceCountUnit: '{count} device(s)',
    viewAllDevices: 'View all devices',
    disableAccount: 'Disable',
    resetPassword: 'Reset Password',
    assignDevices: 'Assign Devices',
    tip: 'Notice',
    deleteConfirm: 'After deleting the account, it can no longer log in to the system. Confirm deletion?',
    employeeName: 'Employee Name: ',
    usernameLabel: 'Username: ',
    currentPermission: 'Current Permission: ',
    assignedDevices: 'Assigned {count} device(s)',
    selectDevice: 'Select Devices: ',
    selectDevicePlaceholder: 'Please select devices',
    deviceHint: 'Selecting no device means the employee can view all devices of the company',
    selectAtLeastOneDevice: 'Please select at least 1 device',
    assignSuccess: 'Devices assigned successfully',
    assignFailed: 'Assignment failed',
    loadDeviceInfoFailed: 'Failed to load device information',
    loadDeviceListFailed: 'Failed to load device list',
    disableConfirmTitle: 'Are you sure to disable this employee account?',
    disableConfirmContent: 'After disabling, the employee will not be able to log in',
    disableSuccess: 'Disabled successfully',
    enableConfirmTitle: 'Are you sure to enable this employee account?',
    enableConfirmContent: 'After enabling, the employee will be able to log in',
    enableSuccess: 'Enabled successfully',
    resetPwdConfirmTitle: 'Are you sure to reset this employee password?',
    resetPwdConfirmContent: 'After resetting, the password will be restored to the default password (JTphoto0515)',
    resetPwdSuccess: 'Password reset successfully',
    addSuccess: 'Employee added successfully',
    updateSuccess: 'Employee updated successfully',
    addTitle: 'Add Employee',
    editTitle: 'Edit Employee',
    accountLabel: 'Account:',
    nameLabel: 'Name:',
    passwordLabel: 'Password:',
    defaultPwdTip: 'Leave blank to use the default password JTphoto0515',
    defaultPwdPlaceholder: 'Leave blank to use default password',
    emailLabel: 'Email:',
    emailInvalid: 'Please enter a valid email',
    maxLength50: 'Length cannot exceed 50 characters',
    mobileLabel: 'Mobile:',
    mobileInvalid: 'Please enter a valid mobile number',
    roleSetting: 'Role:',
    statusSetting: 'Status:',
    selectStatus: 'Please select status',
    genderSetting: 'Gender:',
    selectGender: 'Please select gender',
    deptSetting: 'Department:',
    remarkLabel: 'Remark:',
    remarkPlaceholder: 'Please enter remark',
    submit: 'Submit',
    save: 'Save',
    usernameRequired: 'Username cannot be empty',
    usernameMax20: 'Username cannot exceed 20 characters',
    usernameMin4: 'Username cannot be less than 4 characters',
    usernameExists: 'Sorry, this username already exists',
    mobileRequired: 'Mobile number cannot be empty!',
    nameRequired: 'Name cannot be empty!',
    roleRequired: 'Role cannot be empty!'
  },
  homepage: {
    totalIP: 'Total IP',
    todayfc: 'Today\'s revenue',
    weekQOQ: 'Week QOQ',
    dayQOQ: 'Day QOQ',
    todayCompanyIncome: 'Today Company Income',
    todayPlatformIncome: 'Today Platform Income',
    todayFlow: 'Today Flow',
    todayOrder: 'Today Order',
    todayRefundOrder: 'Today Refund Order',
    machineOnlineCount: 'Machine Online Count',
    machineOfflineCount: 'Machine Offline Count',
    totalPlatformIncome: 'Total Platform Income',
    totalOperatorIncome: 'Total Operator Income',
    totalCompanyIncome: 'Total Company Income',
    totalFlow: 'Total Flow',
    totalOrder: 'Total Order',
    totalRefundOrder: 'Total Refund Order',
    usage: 'Usage',
    incomeAmount: 'Income Amount',
    flow: 'Flow',
    orderCount: 'Order Count',
    todayIncome: 'Today Income',
    lastLoginTime: 'Last Login Time',
    canWithdrawalIncome: 'Can Withdrawal Income',
    goodMorning: 'Good morning',
    goodForenoon: 'Good forenoon',
    goodNoon: 'Good noon',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    welcome1: 'Have a cup of coffee and take a break ☕',
    welcome2: 'Wanna play LOL with friends?',
    welcome3: 'Wanna play Honor of Kings with friends?',
    welcome4: 'You look even better after a few days 😍',
    welcome5: 'How many bugs did you write today 🐞?',
    welcome6: 'Did you chat in the group today?',
    welcome7: 'What delicious food did you eat today?',
    welcome8: 'Did you smile today 😊?',
    welcome9: 'Did you help others solve problems today?',
    welcome10: 'What are you going to eat?',
    welcome11: 'Go to the movies this weekend?',
    dateRange: '{start}~{end}',
    withdraw: 'Withdraw',
    avatarAlt: 'Avatar',
    noDept: 'No Department',
    noRole: 'No Role',
    firstVisit: 'First visit',
    todayIp: 'Today IP',
    todayVisit: 'Today Visit',
    totalVisit: 'Total Visit',
    dateQuery: 'Date Query',
    selectDate: 'Select date',
    today: 'Today',
    lowPaperTitle: 'Low Photo Paper Reminder',
    lowPaperTip: 'The following devices have less than {count} sheets of photo paper left. Please refill the paper in time to avoid affecting normal use!',
    lowPaperDeviceName: 'Device Name',
    lowPaperDeviceCode: 'Device Code',
    lowPaperCount: 'Paper Count',
    lowPaperClose: 'Close'
  },
  device: {
    companyManage: 'Merchant manage',
    deviceManage: 'Device manage',
    totalDevices: 'Total Devices',
    all: 'All',
    online: 'Online',
    offline: 'Offline',
    updating: 'Updating',
    versionUpdate: 'Version update',
    export: 'Export',
    batchUpdate: 'Batch update',
    unbind: 'Unbind',
    bind: 'Bind',
    companyName: 'CompanyName',
    deviceCode: 'DeviceCode',
    appVersion: 'AppVersion',
    sn: 'sn',
    deviceName: 'DeviceName',
    uiName: 'UI Name',
    uiGroupName: 'UI Group',
    photoTime: 'PhotoTime',
    intervalTime: 'IntervalTime',
    pagerNum: 'PagerNum',
    goodsNum: 'GoodsNum',
    filterNum: 'FilterNum',
    address: 'Machine Address',
    orderCount: 'OrderCount',
    operation: 'Operation',
    command: 'The instruction has been successfully issued',
    reset: 'Reset',
    restartApp: 'Restart App',
    showMenu: 'ShowMenu',
    hideMenu: 'HideMenu',
    reportLog: 'Report Log',
    isSupperCoins: 'IsSupperCoins',
    unbinded: 'Unbinded',
    binded: 'Binded',
    bindStatus: 'Bind Status',
    lastestOnlineTime: 'Last Online Time',
    macAddress: 'MAC Address',
    resolution: 'Resolution',
    deviceSN: 'Device SN',
    deviceVersion: 'Device Version',
    deviceKey: 'Device Key',
    deviceIMEI: 'Device IMEI',
    activationCode: 'Machine Code',
    leyaoyaoCode: 'Leyaoyao Code',
    electronicPhoto: 'Electronic Photo',
    scanDownload: 'Scan to download',
    sendFriend: 'Send to friend',
    templateImage: 'Template Image',
    working:'working',
    workStatus:'Work Status',
    showName: 'Device Display Name',
    remark: 'Remark',
    thumbnail: 'Thumbnail',
    remoteCode: 'Remote Code',
    belongCategory: 'Category',
    allMerchants: 'All Merchants',
    assign: 'Assign',
    viewOrders: 'View Orders',
    selectBindMerchant: 'Please select the merchant to bind',
    pendingVendorActive: 'Pending Shouqianba activation',
    vendorActivationCode: 'Shouqianba activation code',
    vendorActivationCodePlaceholder: 'Please enter the Shouqianba activation code',
    vendorActivationCodeRequired: 'Please enter the Shouqianba activation code',
    merchantName: 'Merchant Name',
    selectMerchantName: 'Please select merchant name',
    assignDeviceToSub: 'Assign Device to Sub-merchant',
    deviceLabel: 'Device: ',
    targetMerchant: 'Target Merchant',
    selectSubMerchant: 'Please select a sub-merchant',
    noSubMerchant: 'No sub-merchant available, please create a level-3 merchant first',
    selectTargetMerchant: 'Please select a target merchant',
    assignSuccess: 'Device assigned successfully',
    assignFailed: 'Device assignment failed',
    selectDeviceToUpdate: 'Please select devices to update! At least one',
    setupSuccess: 'Device setup successful',
    updateUI: 'Update UI',
    updateApp: 'Update APP',
    updateConfig: 'Update Config',
    shellExec: 'Shell Command Execution',
    shellCommand: 'Shell Command',
    shellCommandPlaceholder: 'Enter the Shell command to execute, e.g.: ls -la /tmp',
    sendShellCommand: 'Send Shell Command',
    dangerousConfirmTip: 'Dangerous commands require confirmation',
    notifiedUpdateUI: 'Device notified to update UI',
    notifiedUpdateApp: 'Device notified to update APP',
    notifiedUpdateConfig: 'Device notified to update config',
    inputShellCommand: 'Please enter a Shell command',
    dangerousWarningTitle: '⚠️ Dangerous Operation Warning',
    dangerousWarningContent: 'You are executing a dangerous command that may cause device abnormalities! Continue?',
    confirmExecute: 'Confirm',
    commandSent: 'Command sent, please wait for the device to execute',
    sendFailed: 'Send failed',
    networkError: 'Network error, please try again later',
    confirmUnbind: 'After unbinding, the device will be disassociated from the merchant. Are you sure you want to unbind this device?',
    copyCompanyName: 'Copy merchant name',
    copyDeviceCode: 'Copy device code',
    copyActiveCode: 'Copy activation code',
    copySuccess: 'Copied successfully',
    copyFail: 'Copy failed',
    pcInfo: 'PC Info',
    pcName: 'Computer Name',
    pcOs: 'OS',
    pcIp: 'Internal IP',
    pcMac: 'MAC Address',
    pcCpu: 'CPU',
    pcCpuUsage: 'CPU Usage',
    pcMemory: 'Memory(Used/Total)',
    pcMemoryUsage: 'Memory Usage',
    pcTemperature: 'Temperature',
    pcDisk: 'Disk(Free/Total)',
    pcDefaultPrinter: 'Default Printer',
    pcNoPrinter: 'None',
    pcReportTime: 'Report Time'
  },
  setting: {
    navbarColor: 'Navbar color',
    themeColor: 'Theme color',
    navbarPosition: 'Navbar position',
    fixedTopRail: 'Fixed top rail',
    fixedSidebar: 'Fixed sidebar',
    multiTabMode: 'Multi tab mode',
    currency: 'Currency (symbol or code)',
    currencyPlaceholder: 'Select or type, e.g. ¥ / USD / SAR',
    languageSwitching: 'Language switching',
    userCenter: 'User center',
    updatePassword: 'Update password',
    customSystem: 'Custom system',
    logout: 'Logout',
    updateCache: 'Refresh Cache',
    refreshCacheSuccess: 'Cache refreshed successfully',
    refreshCacheFailed: 'Failed to refresh cache'
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    saveSetting: 'Save setting',
    languageChanged: 'Language changed successfully',
    timezoneChanged: 'Timezone changed successfully',
    search: 'Search',
    pleaseInputContent: 'Please input content',
    export: 'Export',
    default: 'Default',
    item: 'Item',
    view: 'View',
    setup: 'Setup',
    status: 'Status',
    showTotal: 'Show {start} ~ {end} records, total {total} records',
    yes: 'Yes',
    no: 'No',
    info: 'Info',
    sequenceNumber: 'Seq',
    creationTime: 'createTime',
    operation: 'Operation',
    defaultSort: 'SortNum',
    type: 'Built-in',
    edit: 'Edit',
    delete: 'Delete',
    deleteSuccess: 'Delete success',
    editSuccess: 'Edit success',
    updateSuccess: 'Updated successfully',
    connectionError: 'The server connection is abnormal, please try again later!',
    reset:'Rest',
    allCategory:'All Category',
    query:'Query',
    add:'Add',
    loadError:'Load Error',
    isDefault:'Default',
    setDefault:'Set Default',
    cancelDefault:'Cancel Default',
    batchEdit:'Batch Edit',
    back:'Back',
    uploadImg:'Upload Image',
    uploadImgSuccess:'Image uploaded successfully',
    uploadImgFailed:'Upload failed',
    uploadImgTips1:'Only JPG, JPEG, GIF, PNG formats are allowed',
    uploadImgTips2:'File exceeds 10M limit, upload not allowed',
    addSuccess:'Added successfully',
    all:'All',
    batchAdd:'Batch Add',
    deleteError:'Delete failed',
    deleteNoData:'Please select the data to delete',
    disable:'Disabled',
    enable:'Enabled',
    exportError:'Export failed!',
    exportExecl:'Export Excel',
    exportSuccess:'Export successful',
    noData:'No Data',
    operateError:'Operation failed, please try again',
    prompt:'Tips',
    searchError:'Search failed',
    selectDataFirst:'Please select the stickers to export first!',
    uploadError:'Upload failed',
    selectAll:'Select All',
    totalRecords:'{total} records in total',
    closeLeft: 'Close Left',
    closeRight: 'Close Right',
    closeOthers: 'Close Others'
  },
  template: {
    merchantManagement: 'Merchant',
    uiManagement: 'UI',
    newConfig: 'Add Frame',
    editFrame: 'Edit Frame',
    editConfig: 'Edit Configuration',
    top: 'Top',
    bottom: 'Bottom',
    builtIn: 'Built-in',
    nonBuiltIn: 'Non-built-in',
    uiConfigName: 'Name',
    background: 'Background',
    wechatOfficialAccount: 'QR Code',
    title: 'Title',
    banner: 'Banner',
    creationTime: 'Creation Time',
    indicatorColor: 'Indicator Color',
    type: 'Type',
    appliedMachines: 'Applied Machines',
    freamName: 'Fream Name',
    editSuccess: 'Edit UI successfully',
    tip: 'Tip',
    deletePrompt: 'Deleting this UI configuration will prevent the user from using it. Are you sure you want to delete it?',
    matchProduct: 'Match Product',
    selectProduct: 'Please select product',
    templateFilePng: 'Template File PNG',
    maxFileSize: 'Max file size is 10M',
    addUploadImage: 'Add Upload Image',
    addHistoryImage: 'Add History Image ',
    previewImage: "PreviewImage",
    cuttingImage: 'Cutting Image',
    groupPhotoFrame: 'Group Photo Frame',
    groupPhotoYes: 'Group Photo',
    groupPhotoNo: 'Non-Group Photo',
    groupPhotoLensSetting: 'Group Photo Lens Setting',
    groupPhotoConfigured: 'Group photo configured',
    groupPhotoNotSet: 'Group photo not set',
    buttonNormal: "Button Normal",
    buttonPressed: "Button Pressed",
    buttonNormalExample: "Normal button example",
    buttonPressedExample: "Pressed button example",
    reuseTemplateFile: "Reuse template file",
    reuseNormalButton: "Reuse normal button",
    reuseAllTemplateFiles: "Reuse all template files",
    addSticker: 'Add Sticker',
    editSticker: 'Edit Sticker',
    StickerIndexNum: 'Index Number',
    onlyImage: 'Only JPG, JPEG, GIF and PNG images can be uploaded',
    selectCategory: 'Please select category',
    selectStatus: 'Please select status',
    selectType: 'Please select type',
    stickerCategory: 'Category',
    stickerCode: 'Sticker Code',
    stickerFileSize: 'File Size',
    stickerName: 'Sticker Name',
    stickerPreview: 'Sticker Image',
    stickerStatus: 'Status',
    stickerType: 'Type',
    staticSticker: 'Static Sticker',
    gifSticker: 'GIF Animation',
    videoSticker: 'Video Sticker',
    frameGroup: 'Frame Group'
  },
  sticker:{
    stickerPreview: "Sticker Image",
    stickerCode:"Sticker Code",
    stickerCategory:'Sticker Category',
    stickerType:'Type',
    stickerSize:'Size',
    stickerFileSize:'File Size',
    StickerIndexNum:'Index Number',
    stickerStatus:'Status',
    stickerName:'Sticker Name',
    stickerOperation:'Operation',
    addSticker:'Add Sticker',
    stickerImage:'Sticker Image',
    stickerThumbnail:'Thumbnail',
    stickerWidth:'Width (Px)',
    stickerHeight:'Height (Px)',
    stickerDuration:'Duration',
    stickerTags:'Tags',
    stickerDescription:'Description',
    statusTips:'Please select status',
    typeTips:'Please select type',
    categoryTips:'Please select category',
    // 贴纸相关
    editSticker: 'Edit Sticker',
    imgPreview: 'Image Preview',
    codeCheckResultErr: '❌ This code already exists, please change it',
    codeCheckResultOk: '✅ Code is available',
    inputCodeTips: 'Optional. Devices distinguish sticker types by code suffix (e.g. ST2D). Uppercase letters, digits and underscores recommended',

    // 贴纸分类
    categoryIcon: 'Category Icon',
    categoryName: 'Category Name',
    categoryCode: 'Category Code',
    categoryIconPlaceholder: 'Please enter icon URL',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',

    // 贴纸分组
    groupNewAdd: 'Add New Group',
    groupEdit:'Edit Group',
    groupName: 'Group Name',
    groupCode: 'Group Code',
    groupIcon: 'Group Icon',
    hasSticker:'Sticker Count ',
    groupCodePlaceholder: 'Please enter group code (uppercase English)',
    groupNamePlaceholder: 'Please enter group name',
    groupDescriptionPHR: 'Please enter group description',

    controllerSticker:'Controller',
    addFailed:'Add failed',
    addSuccess:'Added successfully',
    confirmDeleteSticker:'Are you sure you want to delete this sticker?',
    deleteFailed:'Delete failed',
    deleteSuccess:'Deleted successfully',
    fileDurationDesc:'For video/GIF only, optional',
    fileDurationTips:'Only required for video/GIF stickers',
    fileSizeDesc:'Auto-filled after upload',
    fileSizeExample:'e.g. 51200',
    heightExample:'e.g. 200',
    widthExample:'e.g. 200',
    selectAtLeastOne:'Please select at least one sticker',
    selectSticker:'Select Sticker',
    stickerCodeDesc:'Globally unique identifier, STICKER_XXX format recommended',
    stickerCodeTips:'Please enter sticker code (unique)',
    stickerImageSize:'Recommended size: 200x200 px, PNG/JPG formats supported',
    stickerSlected:'Selected Stickers',
    thumbnail:'Thumbnail',
    uploadStickerImage:'Please upload sticker image',
    inputStickerName:'Please enter sticker name',
    inputStickerCode:'Please enter sticker code',
    codeFormatTips:'STICKER_XXX format is recommended',
    codeExists:'This sticker code already exists, please change it',
    codeValidateFailed:'Validation failed',
    codeValidateError:'Failed to validate code, please try again',
    codeFormatError:'Invalid code format, STICKER_XXX format is recommended',
    codeCheckFailedRetry:'Validation failed, please try again',
    tagsPlaceholder:'Separate multiple tags with commas, e.g.: happy, emoji, smile',
    tagsDesc:'Used for search and categorization',
    descPlaceholder:'Please enter sticker description',
    uploadImage:'Upload Image',
    uploadThumbnail:'Upload Thumbnail',
    reuseStickerImage:'Reuse sticker image',
    reuseStickerImageTip:'Thumbnail will directly use the sticker image, no separate upload needed',
    thumbnailOptional:'Optional, can be auto-generated by the system',
    thumbnailUploadSuccess:'Thumbnail uploaded successfully',
    selectCategoryAttr:'Please select category attribute',
    completeFormInfo:'Please complete the required form fields',
    sortOrderPlaceholder:'The smaller the number, the higher the priority',
    categoryCodePlaceholder:'Please enter category code (uppercase English)',
    categoryCodeDesc:'Unique identifier, uppercase English recommended, e.g.: HOT, CUTE',
    inputCategoryName:'Please enter category name',
    inputCategoryCode:'Please enter category code',
    categoryCodePatternMsg:'Please enter uppercase English, underscores allowed',
    categoryCodeExists:'This category code already exists, please change it',
    uploadCategoryIcon:'Please upload category icon',
    sortOrderMustNumber:'Sort order must be a number',
    categoryDescPlaceholder:'Please enter category description',
    confirmDeleteCategory:'Are you sure you want to delete this category?',
    exportDeveloping:'Export feature is under development...',
    confirmDeleteGroup:'Are you sure you want to delete this group?',
    selectGroupToDelete:'Please select the group(s) to delete',
    inputGroupName:'Please enter group name',
    groupNameTooLong:'Group name cannot exceed 50 characters',
    inputGroupCode:'Please enter group code',
    groupCodeFormatMsg:'Group code can only contain uppercase letters, digits and underscores',
    groupCodeTooLong:'Group code cannot exceed 50 characters',
    groupCodeInvalidOrExists:'Group code format is invalid or already exists, please check',
    uploadGroupIcon:'Please upload group icon',
    sortOrderInvalid:'Please enter a valid sort order (a number >= 0)',
    selectStatusEnableDisable:'Please select status (Enable/Disable)',
    codeCheckErrorTips:'⚠️ Code validation failed, please try again later',
    editFailed:'Edit failed',
    operationFailedRetry:'Operation failed, please retry',
    apiException:'API exception',
    selectStickerType:'Please select sticker type',
    sourceType:'Source',
    allSourceType:'All Sources',
    sourcePlatform:'Platform',
    sourceMerchant:'Merchant',
    copyToMerchant:'Copy to Merchant',
    copyToMerchantTitle:'Copy Group to Merchant',
    copyToMerchantTip:'Copy this platform group and its stickers to the target merchant (creates an owned copy)',
    targetCompanyCode:'Target Merchant Code',
    inputTargetCompanyCode:'Please enter target merchant code',
    copyGroupSuccess:'Group copied successfully',
    copyGroupFailed:'Failed to copy group',
    copy:'Copy',
    manage:'Manage',
    originalGroupName:'Original Group Name',
    newGroupName:'New Group Name',
    inputNewGroupName:'Please enter new group name',
    selectCompany:'Please select merchant',
    targetCompany:'Target Merchant',
    belongCompany:'Merchant',

    //Batch upload stickers
    batchUpload:'Batch Upload',
    batchUploadTitle:'Batch Upload Stickers',
    batchBaseName:'Base Name',
    batchBaseNamePlaceholder:'Please enter the sticker base name',
    batchBaseNameTip:'Each sticker name = base name + two-digit sequence (01, 02 … 99), numbered by file name ascending',
    batchDragText:'Click or drag images to this area to upload',
    batchDragHint:'Multiple files supported, images only (jpg/png/gif/webp/bmp), each ≤1MB, up to 99 per batch',
    batchSelectedCount:'Uploaded {count}',
    batchClearAll:'Clear',
    batchOnlyImage:'Only image formats are supported (jpg/png/gif/webp/bmp)',
    batchSizeLimit:'Each image must not exceed 1MB',
    batchMaxCount:'Up to 99 stickers per batch',
    batchNoSticker:'Please upload at least one sticker first',
    batchUploadPending:'Some images are still uploading, please wait',
    batchSubmitSuccess:'Batch upload succeeded',
    batchSubmitFailed:'Batch upload failed'
  },
  filter: {
    filterName: 'Filter Name',
    addFilter: '+ Add Filter',
    addFilterTitle: 'Add Filter',
    editFilterTitle: 'Edit Filter',
    filterPreview: 'Filter Preview',
    filterOriginalImage: 'Filter Original Image',
    filterResourceFile: 'Filter Resource File',
    belongCompany: 'Merchant',
    allMerchants: 'All Merchants',
    type: 'Type',
    builtIn: 'Built-in',
    nonBuiltIn: 'Not Built-in',
    appliedMachines: 'Applied Machines',
    defaultSort: 'Sort Order',
    serialNo: 'No.',
    batchCopy: 'Batch Copy',
    copy: 'Copy',
    tip: 'Tip',
    deletePrompt: 'Deleting this filter will make it unavailable on machines. Are you sure you want to delete?',
    editFilterSuccess: 'Filter edited successfully',
    loadCompanyFailed: 'Failed to load merchant list',
    copyFilterSuccess: 'Filter copied successfully',
    copyFilterFailed: 'Failed to copy filter',
    batchCopySuccess: 'Filters copied successfully',
    batchCopyFailed: 'Failed to batch copy filters',
    selectFilterFirst: 'Please select the filters to copy first',
    copyToMerchantTitle: 'Copy Filter to Merchant',
    batchCopyTitle: 'Batch Copy Filters to Merchant',
    originalFilterName: 'Original Filter Name',
    newFilterName: 'New Filter Name',
    inputNewFilterName: 'Please enter the new filter name',
    targetMerchant: 'Target Merchant',
    selectCompany: 'Please select a merchant',
    selectedFilters: 'Selected Filters',
    nameSuffix: 'Common Name Suffix',
    inputNameSuffix: 'Please enter the common name suffix',
    nameSuffixTip: 'New filter name = original filter name + this suffix',
    inputFilterName: 'Please enter the filter name',
    inputName: 'Please enter a name',
    selectTypeMsg: 'Please select a type',
    inputDefaultSort: 'Please enter the sort order',
    colorMatrix: 'Color Matrix',
    whitening: 'Whitening',
    smoothing: 'Skin Smoothing',
    bigEye: 'Big Eyes',
    thinFace: 'Slim Face',
    smallFace: 'Small Face',
    forehead: 'Forehead',
    cheekbone: 'Cheekbones',
    nose: 'Nose',
    mouth: 'Mouth',
    chin: 'Chin',
    intensity: 'Filter Intensity',
    sampleFullColor: 'Full-color Sample:',
    colorModeExample: 'Color photo mode sample',
    pngFilterExample: 'PNG filter original sample',
    anyFormatMax10M: 'Any format, up to 10MB',
    colorModeNormal: 'Color Mode - Normal:',
    colorModePressed: 'Color Mode - Pressed:',
    reuseAllSampleColor: 'Reuse Full-color Sample for all',
    addUploadImage: 'Add & upload image',
    uploadFile: 'Upload File',
    reupload: 'Re-upload',
    submit: 'Submit',
    btnNormalRequired: 'Color Mode - Normal image cannot be empty!',
    imageUrlRequired: 'Full-color sample image cannot be empty!',
    filterPngRequired: 'Filter original image cannot be empty!',
    btnSelectedRequired: 'Color Mode - Pressed image cannot be empty!',
    exceed10M: 'Exceeds the 10MB limit, upload not allowed~',
    uploadFailed: 'Upload failed'
  },
  goods: {
    productName: 'Product Name',
    newProductName: 'New Product Name',
    productCode: 'Product Code',
    preview: 'Preview',
    width: 'Width',
    height: 'Height',
    imageCount: 'Photo Count',
    frameTop: 'Frame Top',
    frameBottom: 'Frame Bottom',
    frameLeft: 'Frame Left',
    frameRight: 'Frame Right',
    frameCount: 'Frame Count',
    printMode: 'Print Mode',
    orientation: 'Orientation',
    price: 'Price',
    companyPrice: 'Pricing',
    increasePrice: 'Overprint',
    defaultIncreasePrice: 'Overprint Price',
    companyIncreasePrice: 'Overprint Pricing',
    type: 'Type',
    deviceCount: 'Device Count',
    operation: 'Operation',
    confirmDelete: 'After deletion, machines will not be able to select this product. Are you sure you want to delete it?',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    addProduct: '+ Add Product',
    pleaseInputContent: 'Please enter search content',
    sequenceNumber: 'Seq',
    printingMode: 'Printing Mode',
    oneCopyInDuplicate: 'One original',
    inDuplicate: 'In Duplicate',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    riceConfirmation: 'Please enter the correct price! It can only be greater than or equal to 0.01!',
    cannotEditBuiltIn: 'Built-in products cannot be edited. Only supperAdmin can edit',
    cannotDeleteBuiltIn: 'Built-in products cannot be deleted. Only supperAdmin can delete',
    copy: 'Copy',
    copyProduct: 'Copy Product',
    originalProductName: 'Original Product Name',
    inputProductName: 'Please enter new product name',
    selectCompany: 'Please select merchant',
    copySuccess: 'Product copied successfully',
    copyFrames: 'Copy Frames',
    copyFramesHint: 'Copy all frames under this product',
    copyAsBuiltin: 'Copy as Built-in Product',
    copyAsBuiltinHint: 'No need to select a merchant; the product will be copied to the platform directly',
    batchCopyProduct: 'Batch Copy Products',
    selectedProducts: 'Selected Products',
    nameSuffix: 'Unified Name Suffix',
    inputNameSuffix: 'Please enter unified name suffix',
    nameSuffixTip: 'This suffix will be appended to all copied product names',
    batchCopyPriceTip: 'Price and overprint price default to the first selected product and apply to all copied products',
    batchCopySuccess: 'Products copied successfully',
    selectProductsFirst: 'Please select products to copy first',
    selectProductType: 'Please select product type',
    allProductTypes: 'All Product Types',
    frameManage: 'Frame Management',
    productManage: 'Product Management',
    orderNum: 'Sort Order',
    belongCategory: 'Category',
    belongCompany: 'Merchant',
    subCategory: 'Subcategory',
    groupName: 'Group Name'
  },
  order: {
    printTip: 'Tip',
    printConfirm: 'Do you need to print order: {orderCode}?',
    viewRemotePhotos: 'View Photos',
    remotePrintPhotos: 'Remote Print Photos',
    uploadPhotos: 'Uploaded Photos',
    uploadPrint: 'Upload Print',
    noPhotos: 'No photos',
    orderManagement: 'Order',
    orderList: 'Order List',
    all: 'All',
    paid: 'Paid',
    completed: 'Completed',
    unpaid: 'Unpaid',
    refunded: 'Refunded',
    timeout: 'Timeout',
    canceled: 'Canceled',
    paying: 'Paying',
    unclose: 'Unclosed',
    closed: 'Closed',
    toBeReversed: 'To Be Reversed',
    reversed: 'Reversed',
    evaluated: 'Evaluated',
    exception: 'Exception',
    unknown: 'Unknown',
    payFail: 'Pay Fail',
    notRefund: 'N/A',
    applyRefund: 'Apply Refund',
    refundInProgress: 'Refund In Progress',
    agreeRefund: 'Agree Refund',
    refuseRefund: 'Refuse Refund',
    refundedStatus: 'Refunded',
    refundFail: 'Refund Fail',
    cancelRefund: 'Cancel Refund',
    photo: 'Photo',
    print: 'Print',
    remotePrint: 'Remote Print',
    orderNumber: 'Order Number',
    merchant: 'Merchant',
    deviceNumber: 'Device Number',
    payMode: 'Pay Mode',
    orderType: 'Order Type',
    paymentStatus: 'Payment Status',
    totalPrice: 'Total Price',
    createTime: 'Create Time',
    payTime: 'Pay Time',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    discountAmount: 'Discount Amount',
    refundStatus: 'Refund Status',
    refundReason: 'Order Remark',
    operation: 'Operation',
    export: 'Export',
    orderCount: 'Order Count',
    searchPlaceholder: 'Please enter search content',
    agree: 'Agree Refund',
    refuse: 'Refuse Refund',
    refund: 'Refund',
    viewPhoto: 'View Photo',
    gifImage: 'Animated GIF',
    confirmAgreeRefund: 'Are you sure to approve the refund request for this order?',
    agreeRefundContent: 'After you click OK, this order will be refunded.',
    agreeRefundSuccess: 'Order refund approved successfully',
    confirmRefuseRefund: 'Are you sure to reject the refund request for this order?',
    refuseRefundContent: 'After you click OK, this order will be rejected for refund.',
    refuseRefundSuccess: 'Order refund rejected successfully',
    deviceName:'Device Name',
    viewPhotos: 'Photo Details',
    photoDetail: 'Photo Details',
    compositePhotos: 'Composite Photos',
    originalPhotos: 'Original Photos',
    noCompositePhotos: 'No composite photos',
    noOriginalPhotos: 'No original photos',
    frameId: 'Frame ID',
    noGifImage: 'No animated GIF',
    downloadAllAsZip: 'Download All as ZIP',
    noPhotosToDownload: 'No photos to download',
    downloadSuccess: 'Download successful!',
    downloadFailed: 'Download failed, please try again',
    copyOrderCode: 'Copy order code',
    allMerchants: 'All Merchants',
    allDevices: 'All Devices',
    allPayModes: 'All Payment Methods',
    payWeixin: 'WeChat',
    payAlipay: 'Alipay',
    payShouqianba: 'Shouqianba',
    payDougong: 'Dougong',
    payYunguanjia: 'Cloud Manager',
    payLeyaoyao: 'Leyaoyao',
    payCoins: 'Coin',
    payFree: 'Free',
    payCoupon: 'Redeem Code',
    payDai: 'Token',
    payCoin: 'Coin Payment',
    payCash: 'Cash',
    payCard: 'Card',
    copySuccess: 'Copied successfully',
    copyFail: 'Copy failed',
    delete: 'Delete',
    batchDelete: 'Batch Delete',
    deleteConfirm: 'Are you sure to delete order {orderCode}? Order details and photos on OSS (original, composite, GIF) will also be deleted. This cannot be undone!',
    batchDeleteConfirm: 'Are you sure to delete the selected {count} orders? Order details and photos on OSS will also be deleted. This cannot be undone!',
    deleteSuccess: 'Deleted successfully!',
    deleteFailed: 'Delete failed!',
    selectDeleteFirst: 'Please select orders to delete first!'
  },
  coupon: {
    all: 'All',
    notActivated: 'Not Activated',
    activated: 'Activated',
    used: 'Used',
    cancelled: 'Cancelled',
    searchPlaceholder: 'Please enter coupon code/merchant name/device name',
    export: 'Export',
    generateCoupon: 'Generate Coupons',
    qrCode: 'QR Code',
    noQrCode: 'None',
    clickToPreview: 'Click to preview',
    couponQrCode: 'Coupon QR Code',
    clickToDownload: 'Click image to download',
    confirmCouponInfo: 'Please confirm coupon information',
    merchantName: 'Merchant Name',
    selectMerchant: 'Please select merchant',
    deviceObject: 'Device',
    selectDeviceFirst: 'Please select device first',
    couponQuantity: 'Quantity',
    inputCouponQuantity: 'Please enter quantity',
    activateCoupon: 'Activate Coupon',
    yes: 'Yes',
    no: 'No',
    activate: 'Activate',
    cancel: 'Cancel',
    couponId: 'Coupon ID',
    merchant: 'Merchant',
    deviceName: 'Device Name',
    couponCode: 'Coupon Code',
    status: 'Status',
    createTime: 'Create Time',
    operation: 'Operation',
    activateSuccess: 'Activated successfully!',
    activateFailed: 'Activation failed!',
    cancelSuccess: 'Cancelled successfully!',
    cancelFailed: 'Cancellation failed!',
    generateSuccess: 'Generated successfully!',
    generateFailed: 'Generation failed!',
    generating: 'Generating coupons, please wait...',
    maxCouponLimit: 'Cannot generate more than 500 coupons at once!',
    generateTip: 'A maximum of 500 coupons can be generated at a time. Please generate in batches if more are needed. Each machine can generate up to 2000 coupons per month.',
    selectMerchantFirst: 'Please select merchant first!',
    downloadSuccess: 'Download successful!',
    superCoupon: 'Super Coupon',
    setSuperCoupon: 'Set as Super Coupon',
    setSuperCouponConfirm: 'Are you sure to set this coupon as super coupon? The existing super coupon on this device will be automatically downgraded to a regular coupon.',
    setSuperCouponSuccess: 'Super coupon set successfully!',
    setSuperCouponFailed: 'Failed to set super coupon!',
    delete: 'Delete',
    batchDelete: 'Batch Delete',
    deleteConfirm: 'Are you sure to delete this coupon? It cannot be restored after deletion!',
    batchDeleteConfirm: 'Are you sure to delete the selected {count} coupons? It cannot be restored after deletion!',
    deleteSuccess: 'Deleted successfully!',
    deleteFailed: 'Delete failed!',
    selectDeleteFirst: 'Please select coupons to delete first!',
    expireTime: 'Expiration Time',
    expireTimePlaceholder: 'Select expiration time (leave empty for no expiration)',
    expireTimeTip: 'If not selected, the coupon will never expire. If selected, the coupon cannot be used after this time.',
    noExpire: 'No Expiration'
  },
  dashboard: {
    date: 'Date',
    flow: 'Flow',
    companyCount: 'New Company Count',
    deviceCount: 'New Device Count',
    photoCount: 'Photo Order Count',
    printCount: 'Print Order Count',
    amount: 'Platform Total Income',
    justSumAmount: 'Platform Share',
    companySumAmount: 'Company Share',
    lineCount: 'Device Online Count',
    companyName: 'Company Name',
    deviceCode: 'Device Code',
    activeCode: 'Device Code',
    deviceName: 'Device Name',
    photo: 'Photo Order Count',
    print: 'Print Order Count',
    totalPrice: 'Platform Total Income',
    timeCycle: 'Time',
    defaultTimeFilter: 'Default Time Filter (Month)',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    search: 'Search',
    export: 'Export',
    refund: 'Refund',
    confirmRefund: 'Are you sure to apply for a refund for this order?',
    refundContent: 'After you click OK, this order will initiate a refund request.',
    refundSuccess: 'Order refund application successful',
    confirmAgreeRefund: 'Are you sure to approve the refund request for this order?',
    agreeRefundContent: 'After you click OK, this order will be refunded.',
    agreeRefundSuccess: 'Order refund approved successfully',
    confirmRefuseRefund: 'Are you sure to reject the refund request for this order?',
    refuseRefundContent: 'After you click OK, this order will be rejected for refund.',
    refuseRefundSuccess: 'Order refund rejected successfully',
    timeRangeRequired: 'Time range cannot be empty',
    devicePlaceholder: 'Please select a device',
    allDevices: 'All Devices'
  },
  uiGroup: {
    uiGroupManage: 'UI Group',
    newUIGroup: 'New UI Group',
    searchUIName: 'Search UI Group Name...',
    resourceType: 'Resource Type',
    adminDefine: 'Admin Define',
    merchantDefine: 'Merchant Define',
    uiName: 'UI Name',
    subPageCount: 'Subpage Count',
    downloadPackage: 'Download Package',
    onlyOneInCategoryCannotDelete: 'Only one UI group left in this category (language + product), cannot delete',
    remark: 'Remark',
    createTime: 'Create Time',
    pageManage: 'Page',
    copy: 'Copy',
    copyPrompt: 'Are you sure you want to copy this UI group?',
    copySuccess: 'Copy Successful',
    copyFail: 'Copy Failed',
    copyUIGroup: 'Copy UI Group',
    originalUIName: 'Original UI Group Name',
    newUIName: 'New UI Group Name',
    inputNewUIName: 'Please enter new UI group name',
    selectCompany: 'Please select company',
    companyName: 'Company Name',
    addUIGroup: 'New UI Group',
    deletePrompt: 'Are you sure you want to delete this UI group?',
    deleteSuccess: 'Deletion Successful',
    editUIGroup: 'Edit UI Group',
    editSuccess: 'Edit Successful',
    addSuccess: 'UI Group Added Successfully',
    addFail: 'UI Group Added Failed',
    newPage: 'New Page',
    editPage: 'Edit Page',
    addPage: 'Add Page',
    pageName: 'Page Name',
    pageKey: 'Page Key',
    pageOrder: 'Page Order',
    elementCount: 'Element Count',
    elementManage: 'Element',
    pleaseInputPageName: 'Please enter page name',
    pleaseInputPageKey: 'Please enter page key',
    pleaseInputPageOrder: 'Please enter page order',
    deletePagePrompt: 'Are you sure you want to delete this page? It cannot be restored after deletion!',
    addPageSuccess: 'Page added successfully',
    addPageFail: 'Page added failed',
    editPageSuccess: 'Page edited successfully',
    editPageFail: 'Page edited failed',
    deletePageSuccess: 'Page deleted successfully',
    deletePageFail: 'Page deleted failed',
    pageKeyExists: 'Page key already exists, please change it',

    productType: 'Product Type',
    selectProductType: 'Please select product type',
    elementName: 'Element Name',
    elementType: 'Element Type',
    allElement: 'All Elements',
    editElement: 'Edit Element',
    addElement: 'Add Element',
    elementValue: 'Element Value',
    elementValueMsg: 'Please enter the element value',
    elementKey: 'Element Key',
    elementKeyMsg: 'Please enter the element key',
    elementKeyPlaceholder: 'The element key cannot be duplicated in the same page, recommended to use letters and underscores',
    elementNameMsg: 'Please enter the element name',
    elementTypeMsg: 'Please select the element type',
    elementKeyError: 'The element key already exists on the current page, please change it',
    elemnetDeleteTips: 'Are you sure to delete this element?',
    batchEditElement: 'Batch Edit Elements',
    horizontalLayout: 'Horizontal Layout',
    verticalLayout: 'Vertical Layout',
    loadingElementList: 'Loading element list...',
    allResourceType: 'All Resource Types',
    pleaseInputUIName: 'Please enter the UI group name',
    pleaseSelectResourceType: 'Please select the resource type',
    productManage: 'Product Management',
    previewImage: 'Preview Image',
    reupload: 'Re-upload',
    uploadPreviewImage: 'Upload Preview',
    languageType: 'Language',
    selectLanguageType: 'Please select language',
    pageSize: 'Page Size',
    pixelWH: 'Pixels (W×H)',
    belongCompany: 'Merchant',
    cancelDefaultConfirm: 'Are you sure you want to cancel the default status of this UI group?',
    setDefaultConfirm: 'Are you sure you want to set this UI group as default?',
    operateSuccess: 'Operation successful!',
    operateFail: 'Operation failed',
    onlyJpgPng: 'Only JPG and PNG images can be uploaded!',
    exceed4M: 'Image size cannot exceed 4MB!',
    uploadSuccess: 'Upload successful',
    uploadSuccessNoUrl: 'Upload successful but unable to get the image URL',
    inputImageUrlPlaceholder: 'Or enter an image URL directly (http/https)',
    useImageUrl: 'Use this URL',
    invalidImageUrl: 'Please enter a valid image URL (starting with http:// or https://)',
    imageUrlApplied: 'Image URL applied',
    pasteTip: 'Tip: After copying an image or taking a screenshot, press Ctrl+V/Cmd+V to paste and upload',
    pasteUploadSuccess: 'Pasted image uploaded successfully',
    langZhCN: 'Simplified Chinese',
    langEn: 'English',
    langFr: 'French',
    langKo: 'Korean',
    langZhTW: 'Traditional Chinese',
    langVi: 'Vietnamese',
    langAr: 'Arabic',
    langBih: 'Bosnian',
    langTh: 'Thai',
    langDe: 'German',
    langEs: 'Spanish'
  },
  deviceSetup: {
    title: 'Device Setup',
    basicInfo: 'Basic Information',
    machineModelSN: 'Machine Model [SN]',
    inputMachineSN: 'Please enter machine SN code',
    machineName: 'Machine Name',
    inputMachineName: 'Please enter machine name',
    machineCode: 'Machine Code',
    inputMachineCode: 'Please enter machine code',
    machineAddress: 'Machine Address',
    inputMachineAddress: 'Please enter machine address',
    activationCode: 'Activation Code',
    h5Url: 'H5 Page URL',
    parseUrl: 'Parse URL',
    urlEditorTitle: 'H5 URL Parameter Manager',
    urlBase: 'Base URL',
    urlParams: 'URL Parameters',
    paramName: 'Parameter name',
    paramValue: 'Parameter value',
    addParam: 'Add Parameter',
    noParams: 'No parameters. Click "Add Parameter" to add one',
    done: 'Done',
    pasteTip: 'Tip: After copying an image or taking a screenshot, press Ctrl+V to paste and upload',
    pasteUploadSuccess: 'Pasted image uploaded successfully',
    filterByCompany: 'Filter by company',
    customerServicePhone: 'Customer Service Phone',
    photoAccessType: 'Photo Access Method',
    selectPhotoAccessType: 'Please select type',
    paymentMode: 'Payment Mode',
    selectPaymentMode: 'Please select type',
    onlinePayment: 'Online Payment',
    offlineCoin: 'Offline Coin',
    scanQRCode: 'Scan QR Code',
    addFriend: 'Add Friend',
    machineSettings: 'Machine Settings',
    uiGroupSelection: 'UI Group Selection',
    selectUiGroup: 'Please select UI group',
    uiSelection: 'UI Selection',
    searchUiName: 'Search UI name',
    viewAll: 'All',
    viewSelected: 'Selected Only',
    builtIn: 'Built-in',
    notBuiltIn: 'Not Built-in',
    productSelection: 'Product Selection',
    searchProductName: 'Search product name',
    selectAll: 'Select All',
    frameSelection: 'Frame Selection',
    selectProductFirst: 'Please select product first',
    searchFrameName: 'Search frame name',
    noProductSelected: 'Please select at least one product first, then select a product to view corresponding frames',
    noFrameData: 'No frame data for current product',
    filterSelection: 'Filter Selection',
    searchFilterName: 'Search filter name',
    stickerGroup: 'Sticker Group',
    searchGroupName: 'Search group name',
    noStickerGroupData: 'No sticker group data',
    aiStyleSelection: 'AI Style Assignment',
    searchAiStyleName: 'Search style name',
    aiStyleTip: 'Select the AI styles this device can use; selecting none means no restriction (all visible styles available). Only AI-type devices can be configured.',
    noAiStyleData: 'No available AI style',
    stickersCount: '{count} stickers',
    parameterSettings: 'Parameter Settings',
    photoTime: 'Photo Time',
    seconds: 'seconds',
    inputPhotoTime: 'Please enter photo time',
    intervalTime: 'Interval Time',
    inputIntervalTime: 'Please enter interval time',
    paperCount: 'Paper Count',
    sheets: 'sheets',
    inputPaperCount: 'Please enter paper count',
    paperCountRequired: 'Paper count is required',
    cancel: 'Cancel',
    save: 'Save',
    selectAtLeastOneProduct: 'Please select at least one product',
    selectAtLeastOneFilter: 'Please select at least one filter',
    paperCountMinLimit: 'Paper count cannot be less than 50',
    serverConnectionError: 'Server connection error, please try again later!',
    deviceThumbnail: 'Device Thumbnail',
    modify: 'Modify',
    upload: 'Upload',
    remoteDesktopInfo: 'Remote Desktop Info',
    remoteDesktopPlaceholder: 'Please enter remote desktop info (remote code)',
    format: 'Format',
    belongCategory: 'Category',
    selectBelongCategory: 'Please select category',
    onlyJpgPng: 'Only JPG and PNG images can be uploaded~',
    exceed4M: 'Exceeds 4M limit, upload not allowed~',
    thumbnailUploadFailed: 'Thumbnail upload failed',
    jsonFormatErrorFormat: 'Invalid JSON format, cannot format, please check and retry',
    jsonFormatError: 'Invalid JSON format, please check and retry',
    searchUiGroupName: 'Search UI group name',
    currentUsing: 'Current',
    setCurrentUiGroup: 'Set Current UI Group',
    selectCurrentUiGroup: 'Please select current UI group',
    showName: 'Device Display Name (Scan QR code to download e-photo page title)',
    showNamePlaceholder: 'Displayed as title on electronic photo download page',
    remark: 'Remark',
    remarkPlaceholder: 'Admin remark notes',
    customConfig: 'Custom Config',
    customConfigPlaceholder: 'Please enter custom config in JSON format'
  },
  company: {
    deviceList: 'Device List',
    name: 'TIME PHOTO',
    desc: 'Enjoy the wonderful time!',
    companyName: 'Merchant Name',
    title: 'Merchant Management',
    list: 'Merchant List',
    searchPlaceholder: 'Please enter search content',
    search: 'Search',
    count: 'Merchant Count',
    addAccount: '+ Add Account',
    incoming: 'Incoming',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    incomingQRCode: 'Incoming QR Code',
    tip: 'Tip',
    deleteConfirm: 'Deleting this merchant will also delete its sub-levels. Are you sure you want to delete?',
    maxProductsPerDevice: 'Max products per device',
    maxFramesPerProduct: 'Max frames per product',
    maxFiltersPerDevice: 'Max filters per device',
    maxProductsPerDevicePlaceholder: 'Default 10',
    maxFramesPerProductPlaceholder: 'Default 20',
    maxFiltersPerDevicePlaceholder: 'Default 6',
    limitConfigSection: 'Config Limits',
    companyInfo: 'Merchant Info',
    linkMan: 'Contact Person',
    contactInfo: 'Contact Info',
    cooperationWay: 'Cooperation Mode',
    jointOperation: 'Joint',
    selfOperated: 'Self',
    agent: 'Agent',
    businessStatus: 'Business Status',
    operating: 'Operating',
    stopped: 'Closed',
    hasBackend: 'Backend Enabled',
    backendAccount: 'Backend Account',
    backendPassword: 'Backend Password',
    deviceCount: 'Machine Count',
    orderData: 'Order Data',
    companyRatio: 'Merchant Ratio (%)',
    operatorRatio: 'Operator Ratio (%)',
    companyDesc: 'Merchant Description',
    companyAddress: 'Merchant Address',
    openAggregatedPay: 'Aggregated Payment Enabled',
    thirdPayWay: 'Third-party Payment Method',
    merchantId: 'Merchant ID',
    merchantType: 'Merchant Type',
    merchantAppid: 'Merchant Appid',
    wechatRedirectUrl: 'WeChat Pay Redirect URL',
    payNotifyUrl: 'Payment Callback URL',
    refundNotifyUrl: 'Refund Callback URL',
    sqbMerchantCode: 'Merchant Code (Shouqianba)',
    sqbDeveloperKey: 'Shouqianba Developer Key',
    storeActiveCode: 'Store Activation Code',
    frontendCallbackUrl: 'Frontend Callback URL',
    merchantSecret: 'Merchant Secret',
    unit: '',
    merchantLevel: 'Merchant Level',
    level2Merchant: 'Level 2 Merchant',
    level3Merchant: 'Level 3 Merchant',
    aggregatedPayMerchant: 'Aggregated Payment Merchant',
    backendOpen: 'Backend Open',
    forwardIncomingPrefix: 'Huilaimi Incoming_',
    qrCodeGenerateFailed: 'Failed to generate QR code, please retry',
    invalidWebUrl: 'Invalid web URL obtained, please contact administrator',
    noValidWebUrl: 'No valid web URL obtained',
    fetchDataFailed: 'Failed to fetch data, please retry',
    browserNotSupportDownload: 'Your browser does not support auto download, please right-click to save the image',
    downloadImageFailed: 'Failed to download image, please retry',
    httpError: 'HTTP error, status code: {status}',
    copyCompanyName: 'Copy merchant name',
    copySuccess: 'Copied successfully',
    copyFail: 'Copy failed',
    loginAsMerchant: 'Login as merchant',
    loginAsMerchantNoAccount: 'This merchant has no backend account or password configured'
  },
  income: {
    totalIncome: 'Total Order Amount',
    platformIncome: 'Platform Share',
    companyIncome: 'Merchant System Income',
    subMerchantIncome: 'Sub-merchant Due',
    parentIncome: 'Parent Merchant Retained',
    orderCount: 'Order Count',
    subMerchantIncomeDetail: 'Sub-merchant Income Details',
    subRatioText: 'Sub retained',
    subJustRatioText: 'Parent commission',
    splitRatio: 'Split Ratio',
    deviceCount: 'Device Count',
    deviceCode: 'Device Code',
    deviceName: 'Device Name'
  },
  personal: {
    oldPassword: 'Old Password',
    inputOldPassword: 'Please enter old password',
    strength: 'Strength: ',
    passwordTip: 'Please enter at least 6 characters. Do not use easily guessable passwords.',
    newPassword: 'New Password',
    passwordPlaceholder: 'At least 6 characters, case sensitive',
    confirmPassword: 'Confirm Again',
    confirmPasswordPlaceholder: 'Confirm password',
    levelLow: 'Low',
    levelMedium: 'Medium',
    levelStrong: 'Strong',
    minSixChars: 'Please enter a password of at least 6 characters',
    strengthNotEnough: 'Password strength is not enough',
    inputPassword: 'Please enter password',
    passwordNotMatch: 'The two passwords do not match',
    oldPasswordIncorrect: 'Old password is incorrect',
    editProfile: 'Edit Profile',
    updateAvatar: 'Change Avatar',
    avatarAlt: 'Avatar',
    avatarUpdateSuccess: 'Avatar updated successfully',
    email: 'Email',
    mobile: 'Mobile',
    dept: 'Department',
    gender: 'Gender',
    description: 'Description',
    inputEmail: 'Please enter email',
    inputMobile: 'Please enter mobile number',
    emailInvalid: 'Please enter a valid email',
    emailMax: 'Length cannot exceed 50 characters',
    mobileInvalid: 'Please enter a valid mobile number',
    selectGender: 'Please select gender',
    descMax: 'Length cannot exceed 100 characters',
    submit: 'Submit',
    selectAvatar: 'Select Avatar',
    clickToSelect: 'Click to select',
    updatingWarning: 'Updating avatar, please do not click repeatedly',
    updateAvatarFailed: 'Failed to update avatar',
    tabHthz: 'Houtian Huazi',
    tabAl: 'Ali Series',
    tabLm: 'LianMeng'
  },
  userInfo: {
    title: 'User Info',
    account: 'Account: ',
    role: 'Role: ',
    noRole: 'No role',
    male: 'Male',
    female: 'Female',
    confidential: 'Confidential',
    department: 'Department: ',
    noDepartment: 'No department',
    gender: 'Gender: ',
    phone: 'Phone: ',
    noPhone: 'Phone not bound',
    email: 'Email: ',
    noEmail: 'Email not bound',
    status: 'Status: ',
    locked: 'Locked',
    valid: 'Active',
    createTime: 'Created: ',
    lastLogin: 'Last Login: ',
    description: 'Description: '
  },
  remotePrint: {
    loading: 'Loading...',
    expired: 'Record Expired',
    expiredDesc: 'This upload record has expired. Please return to the terminal and try again.',
    completed: 'Completed',
    completedDesc: 'Photos have been submitted successfully. Please wait near the terminal for printing.',
    submitted: 'Submitted',
    submittedDesc: 'Photos have been sent to the terminal. Please complete the following steps on the machine.',
    orderInfo: 'Order Info',
    recordCode: 'Record No.',
    orderCode: 'Order No.',
    product: 'Product',
    price: 'Price',
    expireTime: 'Expires At',
    photos: 'Photos',
    addPhoto: 'Add Photo',
    tipFormat: 'Only JPG/PNG images are supported',
    tipSize: 'Photos will be auto-compressed to 1844x1200 max',
    tipExpire: 'Record is valid for 5 minutes, please upload quickly',
    submit: 'Upload & Print',
    submitting: 'Submitting...',
    noRecordCode: 'Missing record code. Please scan the QR code.',
    loadFailed: 'Loading failed. Please try again.',
    invalidFormat: 'Only JPG/PNG format is supported',
    photoLimit: 'You can upload up to {count} photos',
    fileTooLarge: 'File size cannot exceed 10MB',
    uploadFailed: 'Upload failed. Please try again.',
    noPhotoUploaded: 'Please upload at least one photo',
    submitFailed: 'Submission failed. Please try again.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en-US.js